export default "__VITE_ASSET__Ch$O8PEu__"